import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { GasInputBoolean } from '@cikrf/gas-utils/decorators';

/** @see https://www.figma.com/file/YDxRp3ZZaGFI4UoB6mCcBr/GAS20_Administration_Vote?node-id=246%3A18411 */

/**
 * @description Компонент для отображения key-value
 * @param title - defines a header.
 * @example <gas-description title="text-title-string"> text-content-string </gas-description>
 */
@Component({
  selector: 'gas-description, gas-key-value',
  templateUrl: './gas-description.component.html',
  styleUrls: ['./gas-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class._size-1]': `size === '1'`,
    '[class._size-3]': `size === '3'`,
    '[class._size-5]': `size === '5'`,
    '[class._size-6]': `size === '6'`,
    '[class._size-8]': `size === '8'`,
    '[class._size-9]': `size === '9'`,
  },
})
export class GasDescriptionComponent {
  @Input()
  public title: string;

  @Input()
  public size: '9' | '8' | '6' | '5' | '3' | '1';

  @GasInputBoolean()
  @Input()
  public divider: string | boolean = false;

  @HostBinding('class._reverse')
  @GasInputBoolean()
  @Input()
  public reverse: string | boolean = false;

  @HostBinding('class._centered-text')
  @GasInputBoolean()
  @Input('centered')
  public isCentered = false;
}
